import { MutationTree } from 'vuex';
import { StateType } from './state';

const mutations: MutationTree<StateType> = {
  initState(state) {
    const lang = window.localStorage.getItem('locale') || window.navigator.language.split('-')[0];
    state.language = { locale: lang };
  },
  setLanguage(state, newLocale) {
    window.localStorage.setItem('locale', newLocale);
    state.language = { locale: newLocale };
    mutations.initState(state);
  },
};

export default mutations;
